export default {
	messages: {
		de: {
			headlines: {
				organizationData: 'Organisationsdaten',
				address: 'Adresse',
				contact: 'Kontakt',
				contacts: 'Kontakte',
			},
		},
		en: {
			headlines: {
				organizationData: 'Organization Data',
				address: 'Address',
				contact: 'Contact',
				contacts: 'Contacts',
			},
		},
	},
};
